// extracted by mini-css-extract-plugin
export default {"character-list":"CharacterList__character-list___EI5ME"};